import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, Subscription, catchError, of } from "rxjs";
import { ConfirmDialogService } from "../confirm-dialog.service";
import { CoreService } from "../core.service";

const DEFAULT_BODY_MESSAGE = "components.confirmDialogComponent.saveMessage";
@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  public showDialog = false;
  private options: any = null;
  public bodyMessage: string = DEFAULT_BODY_MESSAGE;
  private subscriptions = new Subscription();

  constructor(
    private confirmDialogService: ConfirmDialogService,
    private coreService: CoreService,
    private router: Router,
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit() {
    this.confirmDialogService.confirmDialogObservable.subscribe((options) => {
      this.coreService.stopSpinner();
      this.showDialog = true;
      this.options = options;
      if (this.options.bodyMessage) {
        this.bodyMessage = this.options.bodyMessage;
      } else {
        this.bodyMessage = DEFAULT_BODY_MESSAGE;
      }
    });
  }

  public confirmed(): void {
    if (this.options && this.options.confirmedCB) {
      const maybeObservable = this.options.confirmedCB();
      if (maybeObservable instanceof Observable) {
        this.subscriptions.add(
          maybeObservable
            .pipe(
              catchError((error) => {
                void this.router.navigate(["list"]);
                return of(null);
              }),
            )
            .subscribe(),
        );
      }
    }
    this.close();
  }

  public close(): void {
    this.options = null;
    this.showDialog = false;
  }

  public cancel() {
    const cancelledCB = this?.options?.cancelledCB;
    this.close();
    if (cancelledCB) {
      cancelledCB();
    }
  }
}
